import React from "react";
import { Phone, MapPin, ExternalLink, FileText } from "lucide-react";
import { PRACTICE } from "@/data/site";
import { useT } from "@/i18n/LanguageContext";

export default function TopBar() {
  const { t } = useT();
  return (
    <div
      data-testid="top-utility-bar"
      className="hidden md:flex items-center justify-between text-[12px] tracking-[0.18em] uppercase px-6 md:px-10 lg:px-16 py-2.5 bg-[var(--primary)] text-[var(--bg)]/90"
    >
      <div className="flex items-center gap-6">
        <a
          data-testid="top-phone-link"
          href={PRACTICE.phoneHref}
          className="flex items-center gap-2 hover:text-[var(--accent)]"
        >
          <Phone className="w-3.5 h-3.5" strokeWidth={1.6} />
          {PRACTICE.phone}
        </a>
        <a
          data-testid="top-address-link"
          href={PRACTICE.mapUrl}
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-2 hover:text-[var(--accent)]"
        >
          <MapPin className="w-3.5 h-3.5" strokeWidth={1.6} />
          Leesburg, VA
        </a>
      </div>
      <div className="flex items-center gap-6">
        <a
          data-testid="top-pay-online"
          href={PRACTICE.payOnlineUrl}
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-2 hover:text-[var(--accent)]"
        >
          <ExternalLink className="w-3.5 h-3.5" strokeWidth={1.6} />
          {t("Pay Online")}
        </a>
        <a
          data-testid="top-refer-patient"
          href={PRACTICE.referralUrl}
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-2 hover:text-[var(--accent)]"
        >
          <FileText className="w-3.5 h-3.5" strokeWidth={1.6} />
          {t("Refer a Patient")}
        </a>
      </div>
    </div>
  );
}
